export const userDocSetting = (state, rootState) => {
	return rootState.objAuthorize.doc_setting;
}

export const userQuotePrefix = (state, rootState) => {
	return rootState.objAuthorize.quote_prefix;
}

export const defaultUserType = (state, rootState) => {
	return rootState.objAuthorize.default_user_type;
}

export const userOrderPrefix = (state, rootState) => {
	return rootState.objAuthorize.order_prefix;
}

export const userQuoteExpiry = (state, rootState) => {
	return rootState.objAuthorize.quote_expiry;
}

export const userManufacturerDoc = (state, rootState) => {
	return rootState.objAuthorize.manu_user_doc;
}

export const userCustomerDoc = (state, rootState) => {
	return rootState.objAuthorize.cust_user_doc;
}

export const userSpecificDoc = (state, rootState) => {
	return rootState.objAuthorize.spec_user_doc;
}

export const userPublicDoc = (state, rootState) => {
	return rootState.objAuthorize.pub_user_doc;
}

export const userPdfFontsize = (state, rootState) => {
	return rootState.objAuthorize.pdf_setting_fontsize;
}

export const userPageOrientation = (state, rootState) => {
	return rootState.objAuthorize.pdf_setting_orientation;
}

export const userPageNumbers = (state, rootState) => {
	return rootState.objAuthorize.pdf_setting_pagenumbers;
}

export const userStandardTerms = (state, rootState) => {
	return rootState.objAuthorize.pdf_setting_terms;
}

export const userTermsText = (state, rootState) => {
	return rootState.objAuthorize.tc_txt;
}

export const userEditSettings = (state, rootState) => {
	return state.userEditSettings;
}

export const installationActive = (state, rootState) => {
	var installActive = false;
	if ( rootState.objAuthorize.installation_active == 1 ) {
		installActive = true;
	}
	return installActive;
}

export const companyQuote = (state, rootState) => {
	return rootState.objAuthorize.company_quote;
}

export const setupClients = (state, payload) => {
	return state.setupClients;
}

export const kamUsers = (state, payload) => {
	return state.kamUsers;
}

export const branchActive = (state, rootState) => {
  var branchActive = false;
  if ( rootState.objAuthorize.branch_active == 1 ) {
    branchActive = true;
  }
  return branchActive;
}

export const departmentActive = (state, rootState) => {
  var departmentActive = false;
  if ( rootState.objAuthorize.department_active == 1 ) {
    departmentActive = true;
  }
  return departmentActive;
}

export const departmentStatusShare = (state, rootState) => {
  var departmentStatusShare = false;
  if ( rootState.objAuthorize.department_status_share == 1 ) {
    departmentStatusShare = true;
  }
  return departmentStatusShare;
}

export const quoteStatusRankOrder = (state, rootState) => {
  if( rootState.objAuthorize.quote_status_rank_order == null || rootState.objAuthorize.quote_status_rank_order == '0' ) {
    return '0';
  } else {
    return '1';
  }
}

export const userAllowedFileTypes = (state, rootState) => {
  return rootState.objAuthorize.allowed_file_types;
}

export const maxFileUpload = (state, rootState) => {
  return rootState.objAuthorize.max_upload_size;
}

export const installerName = (state, rootState) => {
  return rootState.objAuthorize.installer_name;
}

export const attachmentCategories = (state, rootState) => {
  return state.attachmentCategories;
}

export const manufacturerToken = (state, rootState) => {
  return state.manufacturerToken;
}

export const docShowQuoteDetails = (state, rootState) => {
  var docShowQuoteDetails = false;
  if ( rootState.objAuthorize.doc_show_quote_details == 1 ) {
    docShowQuoteDetails = true;
  }
  return docShowQuoteDetails;
}

export const docShowSoQuoteDetails = (state, rootState) => {
  var docShowSoQuoteDetails = false;
  if ( rootState.objAuthorize.doc_show_so_quote_details == 1 ) {
    docShowSoQuoteDetails = true;
  }
  return docShowSoQuoteDetails;
}

export const docShowCustomerDetails = (state, rootState) => {
  var docShowCustomerDetails = false;
  if ( rootState.objAuthorize.doc_show_customer_details == 1 ) {
    docShowCustomerDetails = true;
  }
  return docShowCustomerDetails;
}

export const docShowDeliveryDetails = (state, rootState) => {
  var docShowDeliveryDetails = false;
  if ( rootState.objAuthorize.doc_show_delivery_details == 1 ) {
    docShowDeliveryDetails = true;
  }
  return docShowDeliveryDetails;
}

export const manufacturerAddress = (state, rootState) => {
  if( rootState.objAuthorize.manufacturer_address != null ) {
    return rootState.objAuthorize.manufacturer_address;
  } else {
    return '';
  }
}

export const collectionDeliveryType = (state, rootState) => {
  return rootState.objAuthorize.collection_delivery_type;
}

export const collectionLabel = (state, rootState) => {
  return rootState.objAuthorize.collection_label;
}

export const deliveryLabel = (state, rootState) => {
  return rootState.objAuthorize.delivery_label;
}

export const isDhl = (state, rootState) => {
  var dhl = false;
  if ( rootState.objAuthorize.is_dhl == 1 ) {
    dhl = true;
  }
  return dhl;
}

export const poTemplate = (state, rootState) => {
  return rootState.objAuthorize.po_template;
}

export const soTemplate = (state, rootState) => {
  return rootState.objAuthorize.so_template;
}

export const quoteTemplate = (state, rootState) => {
  return rootState.objAuthorize.quote_template;
}

export const lookupClientDomain = (state, rootState) => {
  return rootState.objAuthorize.lookup_client_domain;
}

export const lookupClientUser = (state, rootState) => {
  return rootState.objAuthorize.lookup_client_user;
}

export const lookupClientPassword = (state, rootState) => {
  return rootState.objAuthorize.lookup_client_password;
}

export const lookupClientSecret = (state, rootState) => {
  return rootState.objAuthorize.lookup_client_secret;
}

export const lookupClientId = (state, rootState) => {
  return rootState.objAuthorize.lookup_client_id;
}

export const buyMoreLink = (state, rootState) => {
  return rootState.objAuthorize.buy_more_link;
}

export const termsLink = (state, rootState) => {
  return rootState.objAuthorize.terms_link;
}

export const customerCanCollect = (state, rootState) => {
  return rootState.objAuthorize.customer_can_collect;
}

export const productsCanBeDelivered = (state, rootState) => {
  return rootState.objAuthorize.productsCanBeDelivered;
}

export const deliveryOptions = (state, rootState) => {
  return rootState.objAuthorize.delivery_options;
}

export const showClientLogoNotification = (state, rootState) => {
  return rootState.objAuthorize.show_client_logo_notification;
}

export const podCategory = (state, rootState) => {
  return rootState.objAuthorize.pod_category;
}

export const hasStock = (state, rootState) => {
  return rootState.objAuthorize.has_stock;
}

export const hideEcommerce = (state, rootState) => {
  return rootState.objAuthorize.hide_ecommerce;
}

export const hideTrailingZeros = (state, rootState) => {
  return rootState.objAuthorize.hide_trailing_zeros;
}

export const hideVendors = (state, rootState) => {
  return rootState.objAuthorize.hide_vendors;
}

export const vatIncluding = (state, rootState) => {
  return rootState.objAuthorize.vat_including;
}